import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CollectionResponse, CrmCampaignModel } from '@core/models';
import { CatalogsState } from '@core/state/shared';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CrmCampaignsService {
  constructor(private catalogsState: CatalogsState, private http: HttpClient) {}

  public getCrmCampaigns(): Observable<CrmCampaignModel[]> {
    const catalogName = 'crmCampaigns';
    if (this.catalogsState.getState().catalogs[catalogName].totalItems === 0) {
      this.http
        .get<CollectionResponse<CrmCampaignModel>>(
          `${environment.apiUrl}/v1/admin/collections/collection-notices/campaign/catalog`
        )
        .subscribe((response) => {
          this.catalogsState.setCatalogItems(
            response.data.items.sort((a, b) => a.name.localeCompare(b.name)),
            catalogName
          );
        });
    }
    return this.catalogsState.getItems(catalogName) as Observable<
      CrmCampaignModel[]
    >;
  }
}
